"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripleCurlyBraces = exports.SquareBracketsWithHyphens = exports.SquareBracketsWithColons = exports.SquareBrackets = exports.CurlyBracesWithExclamationMarks = exports.Pointy = exports.VerticalBars = exports.PercentSigns = exports.PercentBrackets = exports.Parentheses = exports.Mustache = exports.HTMLComments = exports.HashSymbolsWithCurlyBraces = exports.Handlebars = exports.ExclamationMarks = exports.Dunders = exports.DoubleUnderscores = exports.DoubleSquareBracketsWithDollarSigns = exports.DoubleSquareBrackets = exports.DoubleQuestionMarks = exports.DoubleCurlyBracesWithPercentSign = exports.DoubleCurlyBraces = exports.DoubleColonsWithBraces = exports.DoubleCaretsWithBraces = exports.DoubleAtSigns = exports.DoubleAngle = exports.DollarSignWithCurlyBraces = exports.DollarSignsWithSquareBrackets = exports.CurlyBracesWithHashSymbols = exports.CurlyBracesWithDollarSigns = exports.CurlyBraces = exports.Chevrons = exports.Backticks = exports.AngleBracketsWithPercentSigns = exports.AngleBrackets = exports.findValueByPath = exports.replaceTags = exports.styles = exports.clearCache = exports.environment = exports.timestamp = exports.version = void 0;
// Import functions
var findValueByPath_1 = __importDefault(require("./findValueByPath"));
exports.findValueByPath = findValueByPath_1.default;
var replaceTags_1 = __importDefault(require("./replaceTags"));
exports.replaceTags = replaceTags_1.default;
var cache_1 = require("./cache");
// Import styles
var AngleBrackets_1 = __importDefault(require("./styles/AngleBrackets"));
exports.AngleBrackets = AngleBrackets_1.default;
var AngleBracketsWithPercentSigns_1 = __importDefault(require("./styles/AngleBracketsWithPercentSigns"));
exports.AngleBracketsWithPercentSigns = AngleBracketsWithPercentSigns_1.default;
var Backticks_1 = __importDefault(require("./styles/Backticks"));
exports.Backticks = Backticks_1.default;
var Chevrons_1 = __importDefault(require("./styles/Chevrons"));
exports.Chevrons = Chevrons_1.default;
var CurlyBraces_1 = __importDefault(require("./styles/CurlyBraces"));
exports.CurlyBraces = CurlyBraces_1.default;
var CurlyBracesWithDollarSigns_1 = __importDefault(require("./styles/CurlyBracesWithDollarSigns"));
exports.CurlyBracesWithDollarSigns = CurlyBracesWithDollarSigns_1.default;
var CurlyBracesWithHashSymbols_1 = __importDefault(require("./styles/CurlyBracesWithHashSymbols"));
exports.CurlyBracesWithHashSymbols = CurlyBracesWithHashSymbols_1.default;
var DollarSignWithCurlyBraces_1 = __importDefault(require("./styles/DollarSignWithCurlyBraces"));
exports.DollarSignWithCurlyBraces = DollarSignWithCurlyBraces_1.default;
var DollarSignsWithSquareBrackets_1 = __importDefault(require("./styles/DollarSignsWithSquareBrackets"));
exports.DollarSignsWithSquareBrackets = DollarSignsWithSquareBrackets_1.default;
var DoubleAngle_1 = __importDefault(require("./styles/DoubleAngle"));
exports.DoubleAngle = DoubleAngle_1.default;
var DoubleAtSigns_1 = __importDefault(require("./styles/DoubleAtSigns"));
exports.DoubleAtSigns = DoubleAtSigns_1.default;
var DoubleCaretsWithBraces_1 = __importDefault(require("./styles/DoubleCaretsWithBraces"));
exports.DoubleCaretsWithBraces = DoubleCaretsWithBraces_1.default;
var DoubleColonsWithBraces_1 = __importDefault(require("./styles/DoubleColonsWithBraces"));
exports.DoubleColonsWithBraces = DoubleColonsWithBraces_1.default;
var DoubleCurlyBraces_1 = __importDefault(require("./styles/DoubleCurlyBraces"));
exports.DoubleCurlyBraces = DoubleCurlyBraces_1.default;
var DoubleCurlyBracesWithPercentSigns_1 = __importDefault(require("./styles/DoubleCurlyBracesWithPercentSigns"));
exports.DoubleCurlyBracesWithPercentSign = DoubleCurlyBracesWithPercentSigns_1.default;
var DoubleQuestionMarks_1 = __importDefault(require("./styles/DoubleQuestionMarks"));
exports.DoubleQuestionMarks = DoubleQuestionMarks_1.default;
var DoubleSquareBrackets_1 = __importDefault(require("./styles/DoubleSquareBrackets"));
exports.DoubleSquareBrackets = DoubleSquareBrackets_1.default;
var DoubleSquareBracketsWithDollarSigns_1 = __importDefault(require("./styles/DoubleSquareBracketsWithDollarSigns"));
exports.DoubleSquareBracketsWithDollarSigns = DoubleSquareBracketsWithDollarSigns_1.default;
var DoubleUnderscores_1 = __importDefault(require("./styles/DoubleUnderscores"));
exports.DoubleUnderscores = DoubleUnderscores_1.default;
var Dunders_1 = __importDefault(require("./styles/Dunders"));
exports.Dunders = Dunders_1.default;
var ExclamationMarks_1 = __importDefault(require("./styles/ExclamationMarks"));
exports.ExclamationMarks = ExclamationMarks_1.default;
var HashSymbolsWithCurlyBraces_1 = __importDefault(require("./styles/HashSymbolsWithCurlyBraces"));
exports.HashSymbolsWithCurlyBraces = HashSymbolsWithCurlyBraces_1.default;
var Handlebars_1 = __importDefault(require("./styles/Handlebars"));
exports.Handlebars = Handlebars_1.default;
var HTMLComments_1 = __importDefault(require("./styles/HTMLComments"));
exports.HTMLComments = HTMLComments_1.default;
var Mustache_1 = __importDefault(require("./styles/Mustache"));
exports.Mustache = Mustache_1.default;
var Parentheses_1 = __importDefault(require("./styles/Parentheses"));
exports.Parentheses = Parentheses_1.default;
var PercentBrackets_1 = __importDefault(require("./styles/PercentBrackets"));
exports.PercentBrackets = PercentBrackets_1.default;
var PercentSigns_1 = __importDefault(require("./styles/PercentSigns"));
exports.PercentSigns = PercentSigns_1.default;
var VerticalBars_1 = __importDefault(require("./styles/VerticalBars"));
exports.VerticalBars = VerticalBars_1.default;
var Pointy_1 = __importDefault(require("./styles/Pointy"));
exports.Pointy = Pointy_1.default;
var CurlyBracesWithExclamationMarks_1 = __importDefault(require("./styles/CurlyBracesWithExclamationMarks"));
exports.CurlyBracesWithExclamationMarks = CurlyBracesWithExclamationMarks_1.default;
var SquareBrackets_1 = __importDefault(require("./styles/SquareBrackets"));
exports.SquareBrackets = SquareBrackets_1.default;
var SquareBracketsWithColons_1 = __importDefault(require("./styles/SquareBracketsWithColons"));
exports.SquareBracketsWithColons = SquareBracketsWithColons_1.default;
var SquareBracketsWithHyphens_1 = __importDefault(require("./styles/SquareBracketsWithHyphens"));
exports.SquareBracketsWithHyphens = SquareBracketsWithHyphens_1.default;
var TripleCurlyBraces_1 = __importDefault(require("./styles/TripleCurlyBraces"));
exports.TripleCurlyBraces = TripleCurlyBraces_1.default;
// Build Varialbles populated by Webpack DefinePlugin
// Define version number
exports.version = __VERSION__;
// Define timestamped build
exports.timestamp = __TIMESTAMP__;
// Define environment build
exports.environment = __ENVIRONMENT__;
// Epoxrt main function
exports.default = replaceTags_1.default;
// Export utility functions
exports.clearCache = cache_1.clear;
// Export styles
exports.styles = [
    AngleBrackets_1.default,
    AngleBracketsWithPercentSigns_1.default,
    Backticks_1.default,
    Chevrons_1.default,
    CurlyBraces_1.default,
    CurlyBracesWithDollarSigns_1.default,
    CurlyBracesWithHashSymbols_1.default,
    DollarSignsWithSquareBrackets_1.default,
    DollarSignWithCurlyBraces_1.default,
    DoubleAngle_1.default,
    DoubleAtSigns_1.default,
    DoubleCaretsWithBraces_1.default,
    DoubleColonsWithBraces_1.default,
    DoubleCurlyBraces_1.default,
    DoubleCurlyBracesWithPercentSigns_1.default,
    DoubleQuestionMarks_1.default,
    DoubleSquareBrackets_1.default,
    DoubleSquareBracketsWithDollarSigns_1.default,
    DoubleUnderscores_1.default,
    Dunders_1.default,
    ExclamationMarks_1.default,
    Handlebars_1.default,
    HashSymbolsWithCurlyBraces_1.default,
    HTMLComments_1.default,
    Mustache_1.default,
    Parentheses_1.default,
    PercentBrackets_1.default,
    PercentSigns_1.default,
    VerticalBars_1.default,
    Pointy_1.default,
    CurlyBracesWithExclamationMarks_1.default,
    SquareBrackets_1.default,
    SquareBracketsWithColons_1.default,
    SquareBracketsWithHyphens_1.default,
    TripleCurlyBraces_1.default,
];
